import type { TSeat } from '@core/types';

export const TURN_INDICATOR_HAND_ALPHA = 0; // 暫時隱藏指示手，改由風字高亮提示回合

/** 四家中只有當前回合座位使用 active 風字；null 代表暫時不提示任何一家。 */
export const isSeatWindActiveForTurn = (seat: TSeat, activeTurnSeat: TSeat | null): boolean =>
  seat === activeTurnSeat;
